let joiValidationEnabled = false;

export function setJoiValidationEnabled(enabled: boolean): void {
  joiValidationEnabled = enabled;
}

export function isJoiValidationEnabled(): boolean {
  return joiValidationEnabled;
}
